"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DarkText = _interopRequireDefault(require("../../../DarkText"));

var _TextButton = _interopRequireDefault(require("../../../Button/DarkButton/TextButton"));

var _IconPlus = _interopRequireDefault(require("../../../Icons/IconPlus"));

var _consts = require("../consts");

var _helper = require("../common/helper");

var _styles = require("../common/styles");

var _styles2 = require("./styles");

function AddNewPollButton(_ref) {
  var dispatch = _ref.dispatch;
  var onAddNewPoll = (0, _react.useCallback)(function () {
    dispatch({
      type: _consts.PollTeacherActions.ADD_NEW_POLL
    });
  }, [dispatch]);
  return _react.default.createElement(_TextButton.default, {
    className: (0, _classnames.default)(_styles2.addNewPollButton, 'add-new-poll'),
    onClick: onAddNewPoll
  }, _react.default.createElement(_IconPlus.default, {
    className: "plus-icon"
  }), _react.default.createElement(_DarkText.default, {
    as: "span",
    fontSize: 12,
    color: "amethyst"
  }, "Add new poll"));
}

function PollLiveCompleteStatus(_ref2) {
  var poll = _ref2.poll;
  var isLive = poll.status === _consts.PollStatus.LIVE;
  var totalVoters = poll.totalVoters;
  var responses = (0, _helper.getTotalResponses)(poll);
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.flexAlignCenterStretch, _styles2.pollStatusInfo)
  }, _react.default.createElement(_DarkText.default, {
    className: "poll-status",
    fontSize: 10,
    color: isLive ? 'emerald' : 'cobalt'
  }, isLive ? 'Live' : 'Complete'), _react.default.createElement("span", {
    className: "dot"
  }), _react.default.createElement(_DarkText.default, {
    className: "poll-status",
    fontSize: 10,
    color: "cobalt"
  }, responses, "/", totalVoters, " Votes"));
}

function PollListCard(_ref3) {
  var poll = _ref3.poll,
      dispatch = _ref3.dispatch,
      selected = _ref3.selected;
  var pollId = poll.pollId,
      question = poll.question,
      status = poll.status;
  var onClick = (0, _react.useCallback)(function () {
    dispatch({
      type: _consts.PollTeacherActions.POLL_SELECTED,
      payload: {
        pollId: pollId
      }
    });
  }, [dispatch, pollId]);
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_styles2.pollListCardStyles, 'poll-list-card', {
      selected: selected
    }),
    onClick: onClick,
    role: "presentation"
  }, _react.default.createElement(_DarkText.default, {
    className: "poll-question",
    fontSize: 12,
    color: selected ? 'white' : 'cobalt'
  }, question || 'Untitled Poll'), status === _consts.PollStatus.DRAFT ? _react.default.createElement(_DarkText.default, {
    className: "poll-status",
    fontSize: 10,
    color: "cobalt"
  }, "Draft") : _react.default.createElement(PollLiveCompleteStatus, {
    poll: poll
  }));
}

function PollList(_ref4) {
  var dispatch = _ref4.dispatch,
      polls = _ref4.polls,
      selectedPollId = _ref4.selectedPollId;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_styles2.pollListStyles, 'poll-list')
  }, polls.map(function (poll) {
    return _react.default.createElement(PollListCard, {
      key: poll.pollId,
      poll: poll,
      dispatch: dispatch,
      selected: selectedPollId === poll.pollId
    });
  }), _react.default.createElement(AddNewPollButton, {
    dispatch: dispatch
  }));
}

var _default = PollList;
exports.default = _default;